import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';

export default {
	register(instance = Vue) {
		instance.use(VueObserveVisibility);
	},
};
